import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M8 1.333A6.667 6.667 0 0 0 1.333 8a6.6 6.6 0 0 0 1.507 4.22l-1.333 1.333a.67.67 0 0 0-.14.727.67.67 0 0 0 .633.387h6A6.667 6.667 0 0 0 8 1.333m0 12H3.607l.62-.62a.667.667 0 0 0 0-.94A5.334 5.334 0 1 1 8 13.333"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })